import React, { useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import ReactTooltip from 'react-tooltip';
import Sector from '../../../../assets/img/sector.png';
import InfoBlue from '../../../../assets/img/info-blue.svg';

const Sectors = ( props ) => {
  const {
    classes, filters, isLoading, handleSectorFiltersTest, checkedPrimarySectors, handleSubSectorFiltersTest,
  } = props;

  const [open, setOpen] = useState( !!( checkedPrimarySectors && checkedPrimarySectors.length > 0 ) );
  const [isPrimarySectorFilter, setPrimarySectorFilter] = useState( {} );

  const handleClick = () => {
    setOpen( !open );
  };

  const handlePrimarySector = ( e ) => {
    setPrimarySectorFilter( { [e]: !isPrimarySectorFilter[e] } );
  };
  const renderSubPrimarySectors = ( subInfoData ) => subInfoData.map( ( subInfo ) => {
    let checked = false;
    let list = '';
    if ( checkedPrimarySectors && checkedPrimarySectors.indexOf( subInfo.key ) > -1 ) {
      if ( subInfo.key !== 'Not applicable' ) {
        checked = true;
      }
    }

    if ( subInfo.key !== '' && subInfo.key !== 'Not applicable' ) {
      list = (
        <ListItem button className={classes.subNested} key={subInfo.key}>
          <ListItemText className={classes.filterItem}>
            <FormControlLabel
              className={classes.checkBox}
              control={(
                <Checkbox
                  value={subInfo.key}
                  classes={{
                    root: classes.checkBox,
                    checked: classes.checked,
                  }}
                  checked={checked}
                  onClick={!isLoading && handleSubSectorFiltersTest}
                  disabled={isLoading}
                  disableRipple
                />
                )}
              label={`${subInfo.key} (${subInfo.doc_count})`}
            />
          </ListItemText>
        </ListItem>
      );
    }
    return list;
  } );

  const renderSectors = ( sectors ) => sectors.map( ( info ) => {
    let checked = false;
    let list = '';
    if ( checkedPrimarySectors && checkedPrimarySectors.indexOf( info.key ) > -1 ) {
      if ( info.key !== 'Not applicable' ) {
        checked = true;
      }
    }

    if ( info.key !== '' && info.key !== 'Not applicable' ) {
      list = (
        <React.Fragment key={info.key}>
          <ListItem button className={classes.nested} onClick={() => handlePrimarySector( info.key )}>
            <ListItemText className={classes.filterItem}>
              <FormControlLabel
                className={classes.checkBox}
                control={(
                  <Checkbox
                    value={info.key}
                    classes={{
                      root: classes.checkBox,
                      checked: classes.checked,
                    }}
                    checked={checked}
                    onClick={!isLoading && handleSectorFiltersTest}
                    disabled={isLoading}
                    disableRipple
                  />
                    )}
                label={`${info.key} (${info.doc_count})`}
              />
            </ListItemText>
            {
              isPrimarySectorFilter[info.key] ? <i className="fa fa-caret-up" aria-hidden="true" /> : <i className="fa fa-caret-down" aria-hidden="true" />
            }
          </ListItem>

          <Collapse key={info.key} in={isPrimarySectorFilter[info.key]}>
            {renderSubPrimarySectors( info.by_secondary_sector && info.by_secondary_sector.buckets, info )}
          </Collapse>
        </React.Fragment>
      );
    }
    return list;
  } );

  return (
    <List className={classes.filterMenu}>
      <ListItem button onClick={handleClick} className={classes.filterHead}>
        <ListItemText>
          <img src={Sector} alt="" />
          {' '}
          Sectors
          <img data-for="sectorInfo" data-event="click focus mouseover" data-tip className={classes.infoIcon} src={InfoBlue} alt="" />
          <ReactTooltip id="sectorInfo" className={classNames( classes.reactTooltip, classes.reactTooltipClickableLink )} globalEventOff="mouseover" place="right" type="light" effect="solid">
            <span>
              Sectors are classified according to World Bank Group&apos;s Sector
              {' '}
              <a href="http://pubdocs.worldbank.org/en/538321490128452070/Sector-Taxonomy-and-definitions.pdf" rel="noopener noreferrer" target="_blank">Taxonomy</a>
              {' '}
              and definitions (Revised July 1, 2016)
            </span>
          </ReactTooltip>
        </ListItemText>
        {
          open ? <i className="fa fa-caret-up" aria-hidden="true" /> : <i className="fa fa-caret-down" aria-hidden="true" />
        }
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit className={classes.filterMenuBlock}>
        {
          filters
            ? (
              <List component="div" disablePadding>
                {renderSectors( filters )}
              </List>
            )
            : ( <span className={classes.noFiltersFound}>No filters for Sectors</span> )
        }
      </Collapse>
    </List>
  );
};

Sectors.defaultProps = {
  filters: null,
  isLoading: false,
  checkedPrimarySectors: null,
};

Sectors.propTypes = {
  classes: PropTypes.object.isRequired,
  isLoading: PropTypes.bool,
  filters: PropTypes.arrayOf( PropTypes.object ),
  handleSectorFiltersTest: PropTypes.func.isRequired,
  handleSubSectorFiltersTest: PropTypes.func.isRequired,
  checkedPrimarySectors: PropTypes.arrayOf( PropTypes.string ),
};

export default Sectors;
